import React, { useCallback, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "motion/react";

import RecurringGift from "./RecurringGift";
import StatusButton from "./StatusButton";

export default function RecurringGiftAccordion({
  recurringGifts,
  closedHeight,
  paymentTypeNoun,
}) {
  const [selected, setSelected] = useState("active");
  const containerRef = useRef();
  const [parentHeight, setParentHeight] = useState(0);
  const hasRecurringGifts = Object.keys(recurringGifts)?.length > 0;

  const setCurrentParentHeight = useCallback(() => {
    if (!containerRef.current?.clientHeight) return;
    setParentHeight(containerRef.current.clientHeight);
  }, []);

  useEffect(setCurrentParentHeight, [setCurrentParentHeight]);

  if (!hasRecurringGifts) return null;

  return (
    <GiftsHolder data-cy="recurringGiftAccordion" ref={containerRef}>
      {Object.keys(recurringGifts).map((key) => {
        if (recurringGifts[key]?.length === 0) return null;

        return (
          <div key={key}>
            <StatusButton
              status={key}
              isSelected={selected === key}
              setSelected={setSelected}
              count={recurringGifts[key].length}
              paymentTypeNoun={paymentTypeNoun}
            >
              {key}
            </StatusButton>

            <AnimatePresence>
              {selected === key ? (
                <SectionWrapper
                  $parentHeight={parentHeight}
                  initial="closed"
                  animate="open"
                  exit="closed"
                  variants={{
                    open: { opacity: 1, height: "auto" },
                    closed: { opacity: 0, height: 0 },
                  }}
                  transition={{ duration: 0.3 }}
                  $closedHeight={closedHeight}
                >
                  {recurringGifts[key].map((gift, i) => (
                    <RecurringGift key={i} gift={gift} i={i} />
                  ))}
                </SectionWrapper>
              ) : null}
            </AnimatePresence>
          </div>
        );
      })}
    </GiftsHolder>
  );
}

const GiftsHolder = styled.div`
  flex: 1;
  overflow: hidden;
  font-size: 13px;

  @media screen and (min-width: 1521px) {
    flex-grow: 1;
    overflow: auto;
  }
`;

const SectionWrapper = styled(motion.div)`
  max-height: ${(props) => {
    return `${props.$parentHeight - 190}px`;
  }};
  overflow: auto;

  @media screen and (max-width: 720px) {
    max-height: ${(props) => `calc(100vh - ${props.$closedHeight})`};
  }
`;
